import React from 'react';

const Section = ({ title, children, className = '' }) => (
  <section className={`mb-12 ${className}`}>
    {title && (
      <h2 className="text-2xl font-bold text-gray-900 mb-6">
        {title}
      </h2>
    )}
    {children}
  </section>
);

export default Section;
